import {
  GET_EVENTS,
  CREATE_EVENT,
  GET_EVENT_ERRORS,
  DELETE_EVENT,
  GET_MERGE_EVENTS,
  SET_EVENT_VISITED,
} from 'actions/actionTypes';
import { IEventsState, IEvents } from 'types';

type ActionType =
  | { type: 'GET_EVENTS'; payload: IEvents[] }
  | { type: 'GET_MERGE_EVENTS'; payload: IEvents[] }
  | { type: 'CREATE_EVENT'; payload: IEvents }
  | {
      type: 'GET_EVENT_ERRORS';
      payload: string[];
    }
  | { type: 'DELETE_EVENT'; payload: number }
  | { type: 'SET_EVENT_VISITED'; payload: number };

const initialState: IEventsState = {
  eventsList: [],
  mergeEvents: [],
  errors: [],
};

const events = (state = initialState, action: ActionType): IEventsState => {
  switch (action.type) {
    case GET_EVENTS:
      return {
        ...state,
        eventsList: action.payload,
      };
    case GET_MERGE_EVENTS:
      return {
        ...state,
        mergeEvents: action.payload,
      };
    case CREATE_EVENT:
      return {
        ...state,
        eventsList: [...state.eventsList, action.payload],
      };
    case GET_EVENT_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case DELETE_EVENT: {
      const { eventsList } = state;
      const updatedList = eventsList.filter((e) => e.id !== action.payload);
      return {
        ...state,
        eventsList: updatedList,
      };
    }
    case SET_EVENT_VISITED: {
      const { eventsList } = state;
      const updatedList = eventsList.map((e) => {
        if (e.id === action.payload) {
          e.isStarted = true;
        }
        return e;
      });

      return {
        ...state,
        eventsList: updatedList,
      };
    }
    default:
      return state;
  }
};

export default events;
